import React, { useState, useEffect, Component } from "react";

// Request Handling
import { postData } from "../../../utils/fetch-requests";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";

const EditUserProfileModal = ({ user, setUser, activeModal, dismissModal }) => {
  let updateParams = {
    newPassword: "",
    updatedUser: {
      local: {
        email: user.local.email
      },
      personal: {
        name: user.personal.name,
        phoneNumber: user.personal.phoneNumber,
        profilePictureUrl: user.personal.profilePictureUrl
      },
      roles: user.roles,
      access: {
        level: user.roles
      }
    }
  }

  const updateName = (e) => {
    updateParams.updatedUser.personal.name = e.target.value;
  };

  const updatePhoneNumber = (e) => {
    updateParams.updatedUser.personal.phoneNumber = e.target.value;
  };

  const updateProfilePictureUrl = (e) => {
    updateParams.updatedUser.personal.profilePictureUrl = e.target.value;
  };

  const updateRole = (e) => {
    // update both places where role is kept
    updateParams.updatedUser.roles = e.target.value;
    updateParams.updatedUser.access.level = e.target.value;
  };

  const updateEmail = (e) => {
    updateParams.updatedUser.local.email = e.target.value;
  };

  const updatePassword = (e) => {
    // do not allow empty passwords
    if(e.target.value && e.target.value !== ""){
      updateParams.newPassword = e.target.value;
    }
  };

  const saveAllUserDetails = (dismissModal) => {
    dismissModal("editUserProfileModal");

    postData("/api/user/update-user-details/" + user._id, updateParams)
      .then(res => setUser(res));
  }

  return (
    <Modal
      isOpen={activeModal === "editUserProfileModal"}
      toggle={() => dismissModal("editUserProfileModal")}
    >
      <ModalHeader>User Details</ModalHeader>
      <ModalBody>
        <label>Full Name:</label>
        <Input
          defaultValue={user.personal.name}
          onChange={(event) => updateName(event)}
        />
        <label>Role:</label>
        <Input
          type="select"
          name="role"
          id="role"
          className="form-control mr-1 mb-1"
          defaultValue={updateParams.updatedUser.roles}
          onChange={(event) => updateRole(event)}
        >
          <option value="User">User</option>
          <option value="Account Manager">Account Manager</option>
          <option value="Admin">Admin</option>
          <option value="Super Admin">Super Admin</option>
        </Input>
        <label>Email:</label>
        <Input
          defaultValue={user.local.email}
          onChange={(event) => updateEmail(event)}
        />
        <label>Password: (type a new password)</label>
        <Input
          onChange={(event) => updatePassword(event)}
        />
        <label>Phone Number:</label>
        <Input
          defaultValue={user.personal.phoneNumber}
          onChange={(event) => updatePhoneNumber(event)}
        />
        <label>Profile Picture Url:</label>
        <Input
          defaultValue={user.personal.profilePictureUrl}
          onChange={(event) => updateProfilePictureUrl(event)}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          className="mr-1"
          color="success"
          type="submit"
          onClick={() => saveAllUserDetails(dismissModal)}
        >
          Submit Changes
        </Button>
        <Button
          color="secondary"
          onClick={() => dismissModal("editUserProfileModal")}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default EditUserProfileModal;
